import { isAttr,jsonClone } from '../utils';
import childrenItem from './slot/index';
import {remoteData} from './mixin';
import Vue from 'vue'
import { ACCESS_TOKEN } from "@/store/mutation-types"

//先修改在这里,后续需要优化
function vModel(self, dataObject) {
  dataObject.props.value = self.value;
  dataObject.on.input = val => {
    self.$emit('input', val)
  }
  //判断是否为上传组件
  if(self.conf.compType === 'upload'){
    dataObject.attrs['data'] = {biz:'temp'};
    //for token add by nbacheng 2022-09-07
    const token = Vue.ls.get(ACCESS_TOKEN);
    dataObject.attrs['headers'] = {"X-Access-Token":token};
    dataObject.attrs['before-upload'] = file=>{
      //非限定后缀不允许上传
      const fileName = file.name;
      const suffixName = fileName.split('.').pop();
      
      if(!self.conf.accept.includes(suffixName)){ 
        self.$message.error('该后缀文件不允许上传');
        return false;
      }
      const fileSize = file.size;
      if(fileSize>dataObject.props.fileSize*1024*1024){
        self.$message.error('文件大小超出限制，请检查！');
        return false;
      }
    }
    if (dataObject.props.value != '') {
      const filevalue = JSON.parse(dataObject.props.value);
      filevalue.map(f=>{
        f.url = window._CONFIG['staticDomainURL'] + '/' + f.url;
      });
      dataObject.props['file-list'] = filevalue;
    }

    //for get return file url add by nbacheng 2022-09-07
    dataObject.attrs['on-success'] = file=>{
        //console.log("on-success",file);
        var filename=file.message.substring(file.message.lastIndexOf('/')+1)  //获取文件名称
        let fileObj = {name: filename, url: file.message}
        console.log("dataObject=",dataObject);
        console.log("self.conf=",self.conf);
        let oldValue = [];
        if(dataObject.props.value) {
           oldValue = JSON.parse(dataObject.props.value);
        }else {
          oldValue = [];
        }
        if (oldValue) {
          oldValue.push(fileObj)
        } else {
          oldValue = [fileObj]
        }
        self.$emit('input',JSON.stringify(oldValue));
        console.log("on-success value",oldValue);
    } 
    dataObject.attrs['on-remove'] = (file, fileList) => {
      console.log("on-remove file,fileList",file,fileList);
      let oldValue = JSON.parse(dataObject.props.value);
      console.log("on-remove oldValue",oldValue);
      //file 删除的文件
      //过滤掉删除的文件  
      let newValue = oldValue.filter(item => item.name !== file.name)
      self.$emit('input',JSON.stringify(newValue));
      console.log("on-remove newValue",newValue);
    }
    
    dataObject.attrs['on-error'] = (file) => {
      console.log("on-error file",file);
    }
    
    dataObject.attrs['on-preview'] = (file) => {
      // window.open(file.response.message, "_blank")
      window.open(file.url, "_blank")
    }

    //自定义el-upload的遮罩层slot
    //for get return file url add by nbacheng 2022-09-07
  }
}

//浏览器点击进行下载文件 //for download file add by nbacheng 2022-09-07
function download(file) {
  var a = document.createElement('a');
  var event = new MouseEvent('click');
  a.download = file.name;
  a.href = file.url;
  a.dispatchEvent(event);
}

export default {
  render(h) {
    let dataObject = {
      attrs: {},
      props: {},
      on: {},
      style: {}
    }
    //远程获取数据
    this.getRemoteData();
    const confClone = jsonClone(this.conf);
    const children = childrenItem(h,confClone);
    Object.keys(confClone).forEach(key => {
      const val = confClone[key]
      if (dataObject[key]) {
        dataObject[key] = val
      } else if(key ==='width'){
        dataObject.style= 'width:'+val;
      } else if (!isAttr(key)) {
        dataObject.props[key] = val
      }else {
        if(key !== 'value'){
          dataObject.attrs[key] = val
        }
      }
    })
    /*调整赋值模式，规避cascader组件赋值props会出现覆盖预制参数的bug */
    vModel(this, dataObject);
    //自定义el-upload的遮罩层slot
    if(dataObject.props['list-type'] == "picture-card"){
      dataObject.scopedSlots = {
        file: (props) => {
          let _this = this;
          return h(
            'div',
            { class: 'el-upload-list__item' },
            [
              h('img', {
                class: 'el-upload-list__item-thumbnail',
                attrs: {
                  src: props.file.url,
                  alt: props.file.name
                }
              }),
              h(
                'span',
                { class: 'el-upload-list__item-actions' },
                [
                  h(
                    'span',
                    {
                      class: 'el-upload-list__item-preview',
                      on: {
                        click: () => {
                            let file = props.file;
                            // window.open(file.response.message, "_blank")
                            // window.open(file.url, "_blank")
                            var body = document.getElementsByTagName('body');
                            body[0].style.overflowY = 'hidden';
                            var dialog = document.createElement('div');
                            dialog.id = 'img-dialog';
                            dialog.style.position = 'absolute';
                            dialog.style.top = '0';
                            dialog.style.right = '0';
                            dialog.style.left = '0';
                            // dialog.style.bottom = '0';
                            dialog.style.margin = '30px 400px';
                            // dialog.style.width = '660px';
                            // dialog.style.height = '660px';
                            dialog.style.background = '#fff';
                            dialog.style.padding = '24px';
                            dialog.style.borderRadius = '5px';
                            var span = document.createElement('span');
                            span.innerHTML = "x";
                            span.style.position = 'absolute';
                            span.style.top = '0px';
                            span.style.right = '8px';
                            span.style.fontSize = '25px';
                            span.style.cursor = 'pointer';
                            span.onclick = ()=>{
                              mask.style.display = 'none';
                              body[0].style.overflowY = 'auto';
                            }
                            var img = document.createElement('img');
                            img.src = file.url;
                            img.style.width = '100%';
                            // img.style.height = '100%';
                            img.style.maxHeight = '620px';
                            img.style.border = '1px solid #eee';
                            var mask = document.createElement('div');
                            mask.style.display = 'block';
                            mask.style.width = '100%';
                            mask.style.height = '100%';
                            mask.style.position = 'fixed';
                            mask.style.top = '0';
                            mask.style.zIndex = 999;
                            mask.style.backgroundColor = 'rgba(0,0,0,.45)';
                            var download = document.createElement('button');
                            download.innerHTML = "下载";
                            download.style.position = 'absolute';
                            download.style.bottom = '-10px';
                            download.style.right = '0';
                            download.style.left = '0';
                            download.style.margin = 'auto';
                            download.style.width = '100px';
                            download.style.height = '30px';
                            download.style.background = '#409EFF';
                            download.style.color = '#fff';
                            download.style.border = 'none';
                            download.style.borderRadius = '5px';
                            download.style.cursor = 'pointer';
                            download.onclick = ()=>{
                              window.open(file.url, "_blank")
                            }
                            dialog.appendChild(span);
                            dialog.appendChild(img);
                            dialog.appendChild(download);
                            mask.appendChild(dialog);
                            document.body.appendChild(mask);
                          }
                        }
                    },
                    [
                      h('i', { class: 'el-icon-zoom-in' })
                    ]
                  ),
                  !props.disabled && h(
                    'span',
                    {
                      class: 'el-upload-list__item-delete',
                      on: {
                        click: () => {
                          let file = props.file;
                          window.open(file.url, "_blank")
                        }
                      }
                    },
                    [
                      h('i', { class: 'el-icon-download' })
                    ]
                  ),
                  !props.disabled && h(
                    'span',
                    {
                      class: 'el-upload-list__item-delete',
                      on: {
                        click: () => {
                          let file = props.file;
                          let oldValue = JSON.parse(dataObject.props.value);
                          let newValue = oldValue.filter(item => item.name !== file.name)
                          _this.$emit('input',JSON.stringify(newValue));
                        }
                      }
                    },
                    [
                      h('i', { class: 'el-icon-delete' })
                    ]
                  )
                ]
              )
            ]
          );
        }
      }
    }
    
    console.log("dataObject=",dataObject);
    return h(confClone.ele, dataObject, children)
  },
  props: ['conf','value'],
  mixins:[remoteData]
}
